"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = isDefined;
exports.nonEmptyString = nonEmptyString;
exports.isEmptyString = isEmptyString;
function isDefined(t) {
    return t !== null && t !== undefined;
}
function nonEmptyString(s) {
    return !!s && s.trim() !== '';
}
function isEmptyString(s) {
    return s === null || s === undefined || s.trim() === '';
}
